import React from "react";
import { deleteTicketFile, type TicketFile } from "../../../../api/files";

type Props = {
  ticketId: number;
  file: TicketFile;
  onDelete: () => void;
};

const isImage = (contentType: string) => contentType.startsWith("image/");

export default function AttachmentItem({ ticketId, file, onDelete }: Props) {
  const handleDelete = async () => {
    try {
      await deleteTicketFile(ticketId, file.id);
      onDelete();
    } catch (err) {
      console.error("Delete failed", err);
    }
  };

  return (
    <div className="border border-slate-200 rounded-lg overflow-hidden bg-white shadow-sm">
      <div className="h-32 bg-slate-50 flex items-center justify-center relative">
        {file.url && isImage(file.content_type) ? (
          <img src={file.url} alt={file.filename} className="h-full w-full object-cover" />
        ) : (
          <div className="text-3xl text-slate-400">📄</div>
        )}
        <span className="absolute top-2 right-2 text-[10px] px-2 py-1 rounded-full bg-white border border-slate-200 text-slate-600">
          {file.content_type}
        </span>
      </div>
      <div className="p-3 space-y-1">
        <div className="text-sm font-medium text-slate-900 truncate" title={file.filename}>
          {file.url ? (
            <a className="text-blue-600 hover:underline" href={file.url} target="_blank" rel="noreferrer">
              {file.filename}
            </a>
          ) : (
            file.filename
          )}
        </div>
        <div className="text-xs text-slate-500">
          {file.uploaded_by ? `${file.uploaded_by} • ` : ""}
          {new Date(file.uploaded_at).toLocaleString()}
        </div>
        <div className="pt-2">
          <button
            onClick={handleDelete}
            className="text-xs font-medium text-red-600 hover:text-red-700"
            type="button"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}
